import { Component, OnInit, SimpleChanges, OnChanges, Input, OnDestroy, ViewChild, ElementRef, AfterViewInit, Output,
  EventEmitter, Inject, HostListener, NgZone } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import _ from 'lodash';
import { Router } from '@angular/router';

import { GalleryService } from '../../rest/api/gallery.service';

@Component({
  selector: 'app-virtual-tours',
  animations: [
    trigger('openClose', [
      state('open', style({
        // transform: 'scale(1) translate(-40%, 60px)',
        display: 'block',
        opacity: '1',
        visibility: 'visible'
      })),
      state('closed', style({
        // transform: 'scale(0) translate(-40%, 60px)',
        animationDuration: '5s',
        animationDelay: '5s',
        display: 'block',
        opacity: '0',
        visibility: 'hidden'
      })),
      transition('open => closed', [
        animate('0s')
      ]),
      transition('closed => open', [
        animate('0s')
      ]),
    ]),
    trigger('toggleHighlightReels', [
      state('open', style({
        bottom: '0px',
      })),
      state('closed', style({
        bottom: '-140px',
      })),
    ]),
  ],
  templateUrl: './virtual-tours.component.html',
  styleUrls: ['./virtual-tours.component.scss']
})
export class VirtualToursComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input() isIframeEnabled;
  @Input() spaceData;
  @Input() mediaData;
  @Input() floorplanData;
  @Input() selectedMedia;
  @Input() highLightReelData;
  @Output() seletedMediaEmit = new EventEmitter();

  @ViewChild('mainDiv') mainDiv: ElementRef;
  @ViewChild('rendererContainer') rendererContainer: ElementRef;
  @ViewChild('cssRendererContainer') cssRendererContainer: ElementRef;
  @ViewChild('floorPlanImage') floorPlanImage: ElementRef;
  @ViewChild('sliderContent') selectEvents: ElementRef;

  loading = true;
  active: any;
  // carouselOptions = {
  //   dots: false,
  //   navigation: false,
  //   loop: false,
  //   autoplay: false,
  //   center: false,
  //   margin: 30, responsive: {
  //   0: {
  //       items: 1
  //   },
  //   600: {
  //       items: 3
  //   },
  //   1000: {
  //       items: 4
  //   },
  //   1400: {
  //       items: 6
  //   }
  // }};
  // three js scene and renderer
  scene = null;
  renderer = null;
  cssScene = null;
  cssRenderer = null;
  // VR effect
  effect: any;
  stereoEffect = false;
  // Canvas config
  canvasConfig = {
    CANVAS_HEIGHT: 850,
    CANVAS_WIDTH: 1200,
    CANVAS_CENTER_X: 0,
    CANVAS_CENTER_Y: 0,
  };
  // three js basic controls
  animateId: any;
  controls = null;
  title = null;
  camera = null;
  ambientLight = null;
  pointLight = null;
  geometry = null;
  material = null;
  raycaster = new THREE.Raycaster();
  mouse = new THREE.Vector2(0, 0);
  fullScreen = false;
  fullScreenIphone = false;
  // Basic controls function starts from here
  floorplanToggle = false;
  highlightToggle = false;
  floorplanHotspots: any;
  showFloorPlanHotspotData = false;
  readMoreClicked = false;
  readMoreSummaryClicked = false;
  selectedInfoImage: any;
  selectedInfoTag: any;
  toggle =  true;
  moreClicked = false;
  playIconClicked: any;
  // Space controls config
  spaceConfig = {
    show_drag: 1,
    auto_rotate: 1,
    show_control_buttons: 1,
    show_tour_button: 1,
    highlight_reel_count: 1000,
    vr_enabled: 0,
  };
  // Camera config
  // Camera rotation codes
  cameraConfig = {
    isTweening: false,
    isUserInteracting: false,
    onMouseDownMouseX: 0,
    onMouseDownMouseY: 0,
    lon: 0,
    onMouseDownLon: 0,
    lat: 0,
    onMouseDownLat: 0,
    phi: 0,
    theta: 0,
    clientX: 0,
    clientY: 0,
    controlsSpeed: 600,
    manualControl: false
  };
  cubesObject = null;
  currentMesh = null;
  audioListener: any;
  soundMesh: any;
  audioContext: any;
  // loading = true;
  // Hotspots
  hotspotsMesh = [];
  hotspotsInfoMesh = [];
  infoHotspots = [];
  hoverInfoDiv: any;
  hotspotColor = '#ffc378';
  // highlight reel animation looping images
  autoplayAnimationInterval: any;
  currentHighlightAnimationCount = 1;
  currentHighlightReelData: any;
  stats: any;
  gui: any;
  // Gui controls
  guiControls = {
    dampingFactor: 0,
    rotateSpeed: 0,
    panSpeed: 0
  };
  // Not needed
  pointerEventsNone = false;
  cursorPointer = false;
  imagesData = [];
  sphereMesh = [];
  toolTipHover = false;

  flooplanHotspotClicked = false;

  isAnimating = false;

  mouseBox = null;

  cameraFov = 75;

  loadingManager = new THREE.LoadingManager();

  mousePosition = new THREE.Vector2();

  imgSrc1 = 'assets/images/icons/arrow-icon.png';
  imgSrc2 = 'assets/images/icons/min-icon.png';

  @HostListener('document:fullscreenchange', ['$event'])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  @HostListener('document:mozfullscreenchange', ['$event'])
  @HostListener('document:MSFullscreenChange', ['$event'])
    fullscreenmode() {
      this.fullScreen = !this.fullScreen;
      this.resizeHandler({});
    }

  constructor(@Inject(DOCUMENT) private document: any, public galleryService: GalleryService, private ngZone: NgZone, private router: Router) {
  }

  ngOnInit() {
    const thisobject = this;
    $('body').on('click touchstart', '.hotspot-pulse', (event) => {
      if (event && event.currentTarget && event.currentTarget.id) {
        thisobject.hotspotClickedEvent(event.currentTarget.id);
      }
    });
    $('body').on('click touchstart', '.info-outer', (event) => {
      if (event && event.currentTarget && event.currentTarget.id) {
        thisobject.hotspotInfoClickedEvent(event.currentTarget.id);
      }
    });

    $('body').on('click touchstart', '.open-fullscreen', (event) => {
      this.openFullscreen();
    });

    $('body').on('click touchstart', '.exit-fullscreen', (event) => {
      this.exitFullScreen();
    });

    $('#vrModal').on('show.bs.modal', function (e) {
      if (window.innerWidth < 800) {
        return e.preventDefault();
      }
    });

  }

  // Owl Carousel
  initSlider(response) {
    if (response.length > 0) {
      const cardThis = this;
      this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
        if ($(cardThis.selectEvents.nativeElement)) {
          setTimeout(() => {
            $(cardThis.selectEvents.nativeElement).owlCarousel({
              loop: false,
              margin: 10,
              nav: false,
              autoplay: false,
              smartSpeed: 1000,
              fluidSpeed: true,
              autoplayHoverPause: true,
              responsive: {
                0: {
                  items: 1
                },
                320: {
                  items: 2
                },
                425: {
                  items: 3
                },
                475: {
                  items: 3
                },
                768: {
                  items: 4
                },
                992: {
                  items: 4
                },
                1024: {
                  items: 6
                },
                1366: {
                  items: 7
                },
                1400: {
                  items: 8
                },
                1600: {
                  items: 10
                },
                2000: {
                  items: 10
                }
              }
            });
          }, 300);
        }
      });
    }
  }
  // Owl Carousel

  hotspotClickedEvent(uuid) {
    const hotspotData = _.find(this.hotspotsMesh , (mesh) => {
      if (mesh && mesh.userData && mesh.userData.uuid && mesh.userData.uuid === uuid) {
        return mesh;
      }
    });
    if (hotspotData && hotspotData.userData && hotspotData.userData.media_link && hotspotData.userData.media_link.uuid) {
      this.removeAutoPlay();
      // Change highlight reel if any
      this.changeHighlightReelFromMediaId(hotspotData.userData.media_link.uuid);
      this.animateAndChangeImage(hotspotData.userData, hotspotData.userData.media_link.uuid);
    }
  }

  hotspotInfoClickedEvent(id) {
    this.closeInfoBox();
    this.infoHotspots = _.map(this.infoHotspots, (d) => {
      if (id === d.uuid) {
        d.hidden = false;
        this.galleryService.updateSpaceInfoCount(d.uuid).subscribe((response) => {
        });
      }
      return d;
    });
  }

  removeAutoPlay() {
    this.stopAnimationAutoplay();
    this.playIconClicked = false;
    if (this.controls) {
      this.controls.enableDamping = true;
      this.controls.autoRotate = false;
      this.controls.enableRotate = true;
    }
    if (this.soundMesh) {
      this.soundMesh.pause();
    }
  }

  closeInfoBox() {
    // tslint:disable-next-line:no-conditional-assignment
    if (this.infoHotspots = _.map(this.infoHotspots, (d) => {
    d.hidden = true;
    return d;
    })
  ) {
  this.highlightToggle = false;
  }
    setTimeout(() => {
      this.readMoreClicked = false;
    }, 200);
  }

  ngAfterViewInit(): void {
    this.init();
    setTimeout(() => {
      this.showFloorPlanHotspotData = true;
    }, 2000);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initSlider(this.highLightReelData);
    // Changes in hotspots
    if (changes.selectedMedia && changes.selectedMedia.currentValue) {
      this.selectedMedia = changes.selectedMedia.currentValue;
      this.changeMesh();
      this.updateHiddenTagsInfoMediaHotspot();
    }
    if (changes.spaceData && changes.spaceData.currentValue) {
      this.updateSpaceConfig(changes.spaceData.currentValue.config);
    }
    // Floorplan
    if (changes.floorplanData && changes.floorplanData.currentValue) {
      const floorplanData = changes.floorplanData.currentValue;
      this.floorplanHotspots = floorplanData && floorplanData.hotspot ? floorplanData.hotspot : [];
    }
    // if (changes.isIframeEnabled && changes.isIframeEnabled.currentValue) {
    //   const element  = this.mainDiv.nativeElement;
    //   if (this.router.navigate(['/scenes/iframe/' + this.spaceData.uuid ])) {
    //   } else {
    //     this.fullScreen = true;
    //   }
    // }


    // if (changes.isIframeEnabled && changes.isIframeEnabled.currentValue) {
    //   const element  = this.mainDiv.nativeElement;
    //   if (element.requestFullScreen || element.mozRequestFullScreen || element.msRequestFullscreen || element.webkitRequestFullscreen) {
    //   } else {
    //     this.fullScreenIphone = true;
    //   }
    // }

  }

  toggleFloorplan() {
    this.floorplanToggle = !this.floorplanToggle;
    if (this.floorplanToggle) {
      this.highlightToggle = false;
      this.toggle = false;
    }
  }

  updateHiddenTagsInfoMediaHotspot() {
    this.infoHotspots = [];
    if (this.selectedMedia && this.selectedMedia.hotspot_info && this.selectedMedia.hotspot_info.length > 0) {
      this.selectedMedia.hotspot_info = _.map(this.selectedMedia.hotspot_info, (info) => {
        info.hidden = true;
        this.infoHotspots.push(info);
        return info;
      });
    }
  }

  updateSpaceConfig(configData) {
    this.spaceConfig.show_drag = configData.show_drag ? configData.show_drag : false;
    this.spaceConfig.auto_rotate = configData.auto_rotate  ? configData.auto_rotate : false;
    this.spaceConfig.show_control_buttons = configData.show_control_buttons  ? configData.show_control_buttons : false;
    this.spaceConfig.show_tour_button = configData.show_tour_button  ? configData.show_tour_button : false;
    // update loopHighlightAnimationCountLimit count from space config
    this.spaceConfig.highlight_reel_count = configData.highlight_reel_count  ? configData.highlight_reel_count : 1000;
    // Show vr or not
    this.spaceConfig.vr_enabled = configData.vr_enabled  ? configData.vr_enabled : false;
  }

  init() {
    this.initScene();
    this.initCameraAndLight();
    this.createCubes();
    this.createMultipleCubes();
  }

  initScene() {
    this.scene = new THREE.Scene();
    this.renderer = new THREE.WebGLRenderer();
    this.renderer.setSize( this.canvasConfig.CANVAS_WIDTH, this.canvasConfig.CANVAS_HEIGHT );
    this.rendererContainer.nativeElement.appendChild( this.renderer.domElement );
    // this.scene = new THREE.Scene();
    // this.renderer = new THREE.WebGLRenderer( { alpha: true, antialias: true } );
    // Css renderer
    this.cssScene = new THREE.Scene();
    this.cssRenderer = new THREE.CSS2DRenderer();

    this.canvasConfig.CANVAS_WIDTH = Math.round(parseFloat(getComputedStyle(this.rendererContainer.nativeElement).width));
    this.canvasConfig.CANVAS_HEIGHT = Math.round(parseFloat(getComputedStyle(this.rendererContainer.nativeElement).height));
    this.canvasConfig.CANVAS_CENTER_X = this.canvasConfig.CANVAS_WIDTH / 2;
    this.canvasConfig.CANVAS_CENTER_Y = this.canvasConfig.CANVAS_HEIGHT / 2;

    // Css renderer
    this.cssRenderer.setSize( this.canvasConfig.CANVAS_WIDTH, this.canvasConfig.CANVAS_HEIGHT );
    this.cssRenderer.domElement.style.position = 'absolute';
    this.cssRenderer.domElement.style.top = 0;
    this.cssRendererContainer.nativeElement.appendChild(this.cssRenderer.domElement);

    // VR effect
    // Add the VR screen effect.
    this.effect = new THREE.StereoEffect(this.renderer);
    this.effect.eyeSeparation = 5;
    this.effect.setSize( this.canvasConfig.CANVAS_WIDTH, this.canvasConfig.CANVAS_HEIGHT );

    this.playIconClicked = this.spaceConfig.auto_rotate ? true : false;
    this.cubesObject = new THREE.Object3D();
    this.scene.add( this.cubesObject );

    if (this.isIframeEnabled) {
      const element  = this.mainDiv.nativeElement;
      if (element.requestFullScreen || element.mozRequestFullScreen || element.msRequestFullscreen || element.webkitRequestFullscreen) {
      } else {
        this.fullScreen = true;
      }
    }

  }

  initCameraAndLight() {
    this.camera = new THREE.PerspectiveCamera( this.cameraFov, window.innerWidth / window.innerHeight, 1, 1000 );
    this.camera.position.set( 0, 0, 0.001 );
    // this.camera.position.z = 0.025;
    this.ambientLight = new THREE.AmbientLight( 0xcccccc, 0.4 );
    this.scene.add( this.ambientLight );
    this.pointLight = new THREE.PointLight( 0xffffff, 0.8 );
    this.camera.add( this.pointLight );
    this.scene.add( this.camera );
  }

  initControls() {
    this.controls = new THREE.OrbitControls( this.camera, this.cssRenderer.domElement );
    this.controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
    this.controls.dampingFactor = 0.1;
    this.controls.rotateSpeed = 0.04;
    this.controls.enableZoom = false;
    this.controls.maxDistance = 20;
    if (this.playIconClicked) {
      this.controls.enableRotate = false;
      this.controls.enableDamping = false;
      this.controls.autoRotate = true;
      if (this.currentHighlightReelData && this.currentHighlightReelData.coordinates) {
        this.camera.position.set(this.currentHighlightReelData.coordinates.x, this.currentHighlightReelData.coordinates.y, this.currentHighlightReelData.coordinates.z);
      }
      if (this.soundMesh) {
        this.soundMesh.play();
      }
    } else {
      if (this.soundMesh) {
        this.soundMesh.pause();
      }
    }
    // Play / stop highlight reels
    this.autoPlayHideShowCarousel();
    this.resetCameraPositionForFirstHighlightReel();
  }


  initStats() {
    // stats
    this.stats = new Stats();
    this.cssRendererContainer.nativeElement.appendChild( this.stats.dom );
  }

  initGui() {
    this.gui = new dat.GUI();
    const controlsData = this.gui.addFolder('Controls');
    controlsData.add(this.controls, 'dampingFactor', 0, 100).step(0.2).listen();
    controlsData.add(this.controls, 'rotateSpeed', 0, 100).step(0.2).listen();
    controlsData.add(this.controls, 'panSpeed', 0, 100).step(0.2).listen();
    controlsData.add(this.controls, 'enableDamping').listen();
    controlsData.add(this.controls, 'staticMoving').listen();
    controlsData.add(this.controls, 'screenSpacePanning').listen();
    controlsData.open();
  }

  initMouseBox() {
    const geometry = new THREE.PlaneGeometry(.4, .4);
    const material =  new THREE.MeshBasicMaterial({map: new THREE.TextureLoader().load('assets/marker2.png'),
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 1
    });
    this.mouseBox = new THREE.Mesh( geometry, material);
    this.mouseBox.name = 'mouseSprite';
    this.mouseBox.position.set(0, 0, 0);
    this.mouseBox.renderOrder = 1;
    this.mouseBox.visible = false;
    this.scene.add( this.mouseBox );

    // const geometry = new THREE.RingGeometry( 9.6, 13, 29, 3, 1.5, 7.3 );
    // const material = new THREE.MeshBasicMaterial( { color: 0xffffff, side: THREE.DoubleSide, transparent: true, opacity: 1 } );
    // this.mouseBox = new THREE.Mesh( geometry, material );
    // this.mouseBox.name = 'mouseSprite';
    // this.mouseBox.position.set(0, 0, 0);
    // this.mouseBox.visible = false;
    // this.scene.add( this.mouseBox );
  }

  createCubes() {
    const materialArray = this.createCubeTextureMaterialForSingle(this.selectedMedia);
    const skyBox = new THREE.Mesh( new THREE.BoxGeometry( 500, 500, 500 ), materialArray );
    skyBox.name = this.selectedMedia.uuid;
    skyBox.visible = true;
    this.currentMesh = skyBox;
    this.cubesObject.add(skyBox);
    this.addMediaHotspot(this.selectedMedia, skyBox);
    this.addMediaInfoHotspot(this.selectedMedia, skyBox);
    this.trackOriginalOpacities(skyBox, 1);
  }

  createCubeTextureMaterialForSingle(mediaData) {
    const loadingManager = new THREE.LoadingManager();
    loadingManager.onProgress = (url, count, total) => {
      if (count === 6) {
        this.initMouseBox();
        // Auto play carousel highlight reels
        this.initControls();
        this.addAudioFileVirtualTour();
        this.animate();
        this.loading = false;
      }
    };
    const mediaDatas = {
      cubemap: [mediaData.cubemap[0], mediaData.cubemap[5], mediaData.cubemap[1], mediaData.cubemap[2], mediaData.cubemap[4], mediaData.cubemap[3]]
    };
    const materialArray = [];
    const loader = new THREE.TextureLoader(loadingManager);
    mediaDatas.cubemap.map((url) => {
      const texture = new THREE.MeshBasicMaterial( { map: loader.load(url), side: THREE.DoubleSide, transparent: true, opacity: 1});
      texture.generateMipmaps = false;
      texture.wrapS = texture.wrapT = THREE.ClampToEdgeWrapping;
      texture.minFilter = THREE.LinearFilter;
      materialArray.push(texture);
    });
    return materialArray;
  }

  // createCubes() {
  //   this.scene.add( this.cubesObject );
  //   const materialArray = this.createCubeTextureMaterialForSingle(this.selectedMedia, 1);
  //   const skyBox = new THREE.Mesh( new THREE.BoxGeometry( 500, 500, 500 ), materialArray );
  //   skyBox.name = this.selectedMedia.uuid;
  //   skyBox.visible = false;
  //   this.currentMesh = skyBox;
  //   this.cubesObject.add(skyBox);
  //   this.addMediaHotspot(this.selectedMedia, skyBox);
  //   this.addMediaInfoHotspot(this.selectedMedia, skyBox);
  //   this.trackOriginalOpacities(skyBox, 1);
  // }

  createMultipleCubes() {
    if (this.camera && this.scene) {
      const geometry = new THREE.BoxGeometry( 500, 500, 500 );
      let i;
      for (i = 0; i <  this.mediaData.length; i++) {
        const objectJson =  this.mediaData[i];
        if (objectJson.uuid !== this.selectedMedia.uuid) {
          const materialArray = this.createCubeTextureMaterial(objectJson);
          const skyBox = new THREE.Mesh( geometry, materialArray );
          skyBox.name = objectJson.uuid;
          skyBox.visible = false;
          this.cubesObject.add(skyBox);
          this.trackOriginalOpacities(skyBox, 0);
        }
      }
    }
  }

  // createCubeTextureMaterialForSingle(mediaData, opacityValue) {
  //   let loadedCount = 0;
  //   const loadingManager = new THREE.LoadingManager();
  //   loadingManager.onLoad = () => {
  //      loadedCount++;
  //   };
  //   if (loadedCount === 6) {
  //     this.loading = false;
  //     this.currentMesh.visible = true;
  //   }


  //   const materialArray = [];
  //   const loader = new THREE.TextureLoader(loadingManager);
  //   const textureRight = loader.load( mediaData.cubemap[0] ); // Right
  //   const textureLeft = loader.load( mediaData.cubemap[5] ); // left
  //   const textureTop = loader.load( mediaData.cubemap[1] ); // top
  //   const textureBottom = loader.load( mediaData.cubemap[2] ); // bottom
  //   const textureBack = loader.load( mediaData.cubemap[4] ); // back
  //   const textureFront = loader.load( mediaData.cubemap[3] ); // front
  //   materialArray.push(new THREE.MeshBasicMaterial( { map: textureRight, side: THREE.DoubleSide, transparent: true, opacity: opacityValue }));
  //   materialArray.push(new THREE.MeshBasicMaterial( { map: textureLeft, side: THREE.DoubleSide, transparent: true, opacity: opacityValue  }));
  //   materialArray.push(new THREE.MeshBasicMaterial( { map: textureTop, side: THREE.DoubleSide, transparent: true, opacity: opacityValue  }));
  //   materialArray.push(new THREE.MeshBasicMaterial( { map: textureBottom, side: THREE.DoubleSide, transparent: true, opacity: opacityValue  }));
  //   materialArray.push(new THREE.MeshBasicMaterial( { map: textureBack, side: THREE.DoubleSide, transparent: true, opacity: opacityValue  }));
  //   materialArray.push(new THREE.MeshBasicMaterial( { map: textureFront, side: THREE.DoubleSide, transparent: true, opacity: opacityValue  }));
  //   return materialArray;
  // }

  createCubeTextureMaterial(mediaData) {
    const mediaDatas = {
      cubemap: [mediaData.cubemap[0], mediaData.cubemap[5], mediaData.cubemap[1], mediaData.cubemap[2], mediaData.cubemap[4], mediaData.cubemap[3]]
    };
    const materialArray = [];
    const loader = new THREE.TextureLoader(this.loadingManager);
    mediaDatas.cubemap.map((url) => {
      const texture = new THREE.MeshBasicMaterial( { map: loader.load(url), side: THREE.DoubleSide, transparent: true, opacity: 0});
      texture.generateMipmaps = false;
      texture.wrapS = texture.wrapT = THREE.ClampToEdgeWrapping;
      texture.minFilter = THREE.LinearFilter;
      materialArray.push(texture);
    });
    return materialArray;
  }

  // Link hotspot
  addMediaHotspot(jsonData, skyBox) {
    if (jsonData && jsonData.hotspot) {
      let i;
      for (i = 0; i < jsonData.hotspot.length; i++) {
        const hotspots = jsonData.hotspot[i];

        // Enable hotspot linked media visibility
        const cubesObject = this.cubesObject.children ? this.cubesObject.children : [];
        const sphereMesh = _.find(cubesObject, {name: hotspots.media_link.uuid });
        if (sphereMesh) {
          sphereMesh.visible = true;
        }
        this.createMediaHotspot(hotspots, skyBox);
      }
    }
  }

  createMediaHotspot(hotspot, skyBox) {
    const color = hotspot.color ? hotspot.color : this.hotspotColor;
    let content = '';
    const rgbcolor1 = this.hexToRgbA(color, 0.7);
    const rgbcolor2 = this.hexToRgbA(color, 0);
    content += '<div class="hotspot-pulse" data-id="' + hotspot.uuid + '" id="' + hotspot.uuid + '" data-color="' + color + '" style="--rgbcolor1: ' + rgbcolor1 + ';--rgbcolor2: ' + rgbcolor2 + ';border: 5px solid ' + color + '">';
    content += '<div class="pulse" style="border: 2px solid ' + color + '" >';
    content += '<div class="hotspot-title"><p> ' + hotspot.title + ' </p></div>';
    content += '</div>';
    content += '</div>';
    const element = document.createElement('div');
    element.innerHTML = content;

    const sprite = new THREE.CSS2DObject( element );
    sprite.position.set(hotspot.coordinates.x, hotspot.coordinates.y, hotspot.coordinates.z);
    sprite.name = hotspot.uuid;
    sprite.hotspot_type = 'link';
    sprite.userData = hotspot;
    this.hotspotsMesh.push(sprite);
    skyBox.add( sprite );
  }
  // Link hotspot

  // Info hotspots
  addMediaInfoHotspot(selectedMedia, skyBox) {
    if (selectedMedia && selectedMedia.hotspot_info) {
      let i;
      for (i = 0; i < selectedMedia.hotspot_info.length; i++) {
        const hotspots = selectedMedia.hotspot_info[i];
        this.createMediaInfoHotspot(hotspots, skyBox);
      }
    }
  }

  createMediaInfoHotspot(hotspot, skyBox) {
    let content = '';
    let display = 'block';
    if (!hotspot.show_info_hotspot) {
      display = 'none';
    }
    content += '<div class="info-outer" style="display: "' + display + '" id="' + hotspot.uuid + '" data-id="' + hotspot.uuid + '">';
    content += '<div class="info-hotspot-pulse">';
    content += '<div class="info-icon">';
    content += '<img src="assets/images/icons/main-info.png">';
    content += '</div>';
    content += '</div>';
    content += '</div>';
    const element = document.createElement('div');
    element.innerHTML = content;
    const sprite = new THREE.CSS2DObject( element );
    sprite.position.set(hotspot.coordinates.x, hotspot.coordinates.y, hotspot.coordinates.z);
    sprite.name = hotspot.uuid;
    sprite.hotspot_type = 'info';
    sprite.userData = hotspot;
    this.hotspotsInfoMesh.push(sprite);
    skyBox.add( sprite );
  }

  hexToRgbA(hex, opacity) {
    let c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        // tslint:disable-next-line:no-bitwise
        return 'rgba(' + [(c >> 16) & 255, ( c >> 8) & 255, c & 255].join(',') + ', ' + opacity + ' )';
    }
    throw new Error('Bad Hex');
  }

  addAudioFileVirtualTour() {
    if (this.spaceData && this.spaceData.audio && this.spaceData.audio !== '' && this.spaceData.audio !== null) {
      this.audioContext = new AudioContext();
      this.audioContext.resume().then(() => {
        console.log('Playback resumed successfully');
      });
      // create an AudioListener and add it to the camera
      this.audioListener = new THREE.AudioListener();
      this.camera.add( this.audioListener );
      // create a global audio source
      this.soundMesh = new THREE.Audio( this.audioListener );
      // load a sound and set it as the Audio object's buffer
      const audioLoader = new THREE.AudioLoader();
      // tslint:disable-next-line:only-arrow-functions
      audioLoader.load( this.spaceData.audio, ( buffer ) => {
        if (this.soundMesh) {
          this.soundMesh.setBuffer( buffer );
          this.soundMesh.setLoop( true );
          this.soundMesh.setVolume( 1 );
          if (this.playIconClicked) {
            this.soundMesh.play();
          } else {
            this.soundMesh.pause();
          }
        }
      });
    }
  }

  animate() {
    this.animateId = requestAnimationFrame(this.animate.bind(this));
    if (this.renderer && this.controls && this.camera) {
      this.controls.update();
      // this.stats.update();
      TWEEN.update();
      this.render();
    }
  }

  render() {
    if (this.renderer) {

      if (this.mouseBox) {
        if (!this.detectMob()) {
          const rayCaster = new THREE.Raycaster();
          rayCaster.setFromCamera(this.mousePosition, this.camera);
          const intersects = rayCaster.intersectObjects( [this.currentMesh], true );
          if ( intersects.length > 0 ) {
            this.mouseBox.visible = true;
            this.mouseBox.position.set( 0, 0, 0 );
            this.mouseBox.lookAt( intersects[ 0 ].face.normal );
            const position = rayCaster.ray.at(3.0);
            // const position = {
            //   x: intersects[ 0 ].point.x * 0.01,
            //   y: intersects[ 0 ].point.y * 0.01,
            //   z: intersects[ 0 ].point.z * 0.01,
            // };
            this.mouseBox.position.copy( position );
          } else {
            this.mouseBox.visible = false;
          }
        } else {
          this.mouseBox.visible = false;
        }
      }

      if (this.stereoEffect) {
        this.effect.render(this.scene, this.camera);
      } else {
        this.renderer.render(this.scene, this.camera);
      }
    }
    if (this.cssRenderer) {
      this.cssRenderer.render( this.scene, this.camera );
    }
  }

  detectMob() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem): any => {
        return navigator.userAgent.match(toMatchItem);
    });
  }


  resizeHandler(event) {

    if (this.renderer) {
      if ( this.fullScreen) {
        if ( navigator.userAgent.match('CriOS') ) {
          this.canvasConfig.CANVAS_WIDTH = window.outerWidth;
          this.canvasConfig.CANVAS_HEIGHT = window.outerHeight;
        } else {
          this.canvasConfig.CANVAS_WIDTH = window.innerWidth;
          this.canvasConfig.CANVAS_HEIGHT = window.innerHeight;
        }
      } else {
        this.canvasConfig.CANVAS_WIDTH = Math.round(parseFloat(getComputedStyle(this.rendererContainer.nativeElement).width));
        this.canvasConfig.CANVAS_HEIGHT = Math.round(parseFloat(getComputedStyle(this.rendererContainer.nativeElement).height));
      }
      this.camera.aspect = this.canvasConfig.CANVAS_WIDTH / this.canvasConfig.CANVAS_HEIGHT;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize( this.canvasConfig.CANVAS_WIDTH, this.canvasConfig.CANVAS_HEIGHT );
      // Css renderer
      this.cssRenderer.setSize( this.canvasConfig.CANVAS_WIDTH, this.canvasConfig.CANVAS_HEIGHT );
    }
    // Vr effect
    if (this.effect) {
      this.effect.setSize( this.canvasConfig.CANVAS_WIDTH, this.canvasConfig.CANVAS_HEIGHT );
    }
  }

  // toggle fullscreen

  // toggle fullscreen

  openFullscreen() {
    if (!this.fullScreen) {
      const element  = this.mainDiv.nativeElement;
      if (element.requestFullScreen) {
          element.requestFullScreen();
      } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
      } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
      } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
      } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
      } else {
        this.router.navigate(['/scenes/iframe/' + this.spaceData.uuid ]);
        this.fullScreen = true;
      }
      // if (element.requestFullscreen) {
      //   element.requestFullscreen();
      // } else if (element.mozRequestFullScreen) {
      //   element.mozRequestFullScreen();
      // } else if (element.webkitRequestFullscreen) {
      //   element.webkitRequestFullscreen();
      // } else if (element.msRequestFullscreen) {
      //   element.msRequestFullscreen();
      // }
    }
    if ($('.ng-tooltip-show') && $('.ng-tooltip-show').length > 0) {
      $('.ng-tooltip-show').each(function() {
        $(this).remove();
      });
    }
  }

  exitFullScreen() {
    if (this.fullScreen || this.fullScreenIphone) {
      this.isIframeEnabled = false;
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        this.document.msExitFullscreen();
      } else {
        this.router.navigate(['/scenes/' + this.spaceData.uuid ]);
      }
    }
  }

  enableVrMode() {
    this.stereoEffect = !this.stereoEffect;
    this.resizeHandler(true);
    this.render();
  }

  // Controls functions
  nextImage() {
    if (this.isAnimating) {
      return;
    }
    const cubesObject = this.cubesObject.children ? this.cubesObject.children : [];
    const currentIndex = _.findIndex(cubesObject, {name: this.currentMesh.name });
    const nextIndex = currentIndex + 1;
    if (cubesObject && cubesObject[nextIndex]) {
      this.isAnimating = true;
      this.controls.enableRotate = false;
      const oldMesh = this.currentMesh;
      const newMesh = cubesObject[nextIndex];
      this.removeAutoPlay();
      // Remove hotspots
      this.removeHotspotMesh();
      this.changeHighlightReelFromMediaId(newMesh.name);
      this.tweenPreviousNextImage(newMesh, 'in', 1000);
      this.tweenPreviousNextImage(oldMesh, 'out', 2000);
    }
  }

  previousImage() {
    if (this.isAnimating) {
      return;
    }
    const cubesObject = this.cubesObject.children ? this.cubesObject.children : [];
    const currentIndex = _.findIndex(cubesObject, {name: this.currentMesh.name });
    if (currentIndex > 0) {
      this.controls.enableRotate = false;
      const previousIndex = currentIndex - 1;
      if (cubesObject && cubesObject[previousIndex]) {
        this.isAnimating = true;
        const oldMesh = this.currentMesh;
        const newMesh = cubesObject[previousIndex];
        this.removeAutoPlay();
        // Remove hotspots
        this.removeHotspotMesh();
        this.changeHighlightReelFromMediaId(newMesh.name);
        this.tweenPreviousNextImage(newMesh, 'in', 1000);
        this.tweenPreviousNextImage(oldMesh, 'out', 2000);
      }
    }
  }

  changeMedia(media) {
    const cubesObject = this.cubesObject && this.cubesObject.children ? this.cubesObject.children : [];
    const nextIndex = _.findIndex(cubesObject, {name: media.uuid });
    if (cubesObject && cubesObject[nextIndex]) {
      const oldMesh = this.currentMesh;
      const newMesh = cubesObject[nextIndex];
      if (oldMesh.name !== newMesh.name) {
        this.controls.enableRotate = false;
        // Remove hotspots
        this.removeHotspotMesh();
        this.tweenPreviousNextImage(newMesh, 'in', 1000);
        this.tweenPreviousNextImage(oldMesh, 'out', 2000);
      }
    }
  }

  tweenPreviousNextImage(mesh, direction, time) {
    const originals = mesh.userData.originalOpacities;
    const current = { percentage: direction === 'in' ? 0 : 1 };
    const tweenOpacity = new TWEEN.Tween(current)
    .to({ percentage: direction === 'in' ? 1 : 0 }, time)
    .easing(TWEEN.Easing.Linear.None)
    .onUpdate(() => {
      let i;
      for (i = 0; i < mesh.material.length; i++) {
        if (direction === 'in') {
          mesh.material[i].opacity = current.percentage;
        } else {
          mesh.material[i].opacity = originals[i] * current.percentage;
        }
      }
    })
    .onComplete(() => {
      if (direction === 'out') {
        mesh.visible = false;
        this.trackOriginalOpacities(mesh, 0);
      } else if (direction === 'in') {
        this.trackOriginalOpacities(mesh, 1);
        this.currentMesh = mesh;
        const selectedMedia = _.find(this.mediaData, {uuid:  mesh.name});
        if (!this.controls.autoRotate) {
          this.controls.enableRotate = true;
        }
        if (this.flooplanHotspotClicked) {
          this.flooplanHotspotClicked = false;
        }
        this.isAnimating = false;
        this.seletedMediaEmit.emit(selectedMedia);
      }
    });
    tweenOpacity.start();
  }

  trackOriginalOpacities(mesh, opacity) {
      const opacities = [];
      const materials = mesh.material ? mesh.material : [];
      let i;
      for (i = 0; i < materials.length; i++) {
        opacities.push(opacity);
      }
      mesh.userData.originalOpacities = opacities;
  }

  animateAndChangeImage(hotspotData, uuid) {
    if (this.isAnimating) {
      return;
    }
    if (uuid && this.camera) {
      this.removeHotspotMesh();
      this.isAnimating = true;
      this.controls.enableRotate = false;
      const oldMesh = this.currentMesh;
      this.hotspotsMesh = [];
      _.map(this.cubesObject.children, (mesh) => {
        if (mesh.name === uuid) {
          this.currentMesh = mesh;
        }
        return mesh;
      });
      this.currentMesh.visible = true;
      const currentCameraFov = this.camera.fov;
      const tween = new TWEEN.Tween(this.camera).to({fov: currentCameraFov - 10}, 800);
      const selectedMedia = _.find(this.mediaData, {uuid: this.currentMesh.name});
      tween.onStart(() => {
        this.tweenPreviousNextImage(this.currentMesh, 'in', 1000);
        this.tweenPreviousNextImage(oldMesh, 'out', 2000);
      });
      tween.onUpdate(() => {
        this.camera.updateProjectionMatrix();
      });
      tween.onComplete(() => {
        if (hotspotData && hotspotData.orientation && hotspotData.orientation !== '') {
          // this.camera.position.set( 0, 0, 0.001 );
          this.camera.position.set(hotspotData.orientation.x, hotspotData.orientation.y, hotspotData.orientation.z);
        }
        this.camera.fov = currentCameraFov;
        this.camera.updateProjectionMatrix();
        this.controls.enableRotate = true;
        this.seletedMediaEmit.emit(selectedMedia);

      });
      tween.easing(TWEEN.Easing.Linear.None);
      tween.start();
    }
  }

  changeMesh() {
    if (this.selectedMedia && this.cubesObject && this.cubesObject.children) {
      // Remove hotspots
      this.removeHotspotMesh();

      // Visible off for every cubes
      _.map(this.cubesObject.children, (mesh) => {
        if (mesh.name !== this.selectedMedia.uuid) {
          mesh.visible = false;
        }
        return mesh;
      });

      _.map(this.cubesObject.children, (mesh) => {
        if (mesh.name === this.selectedMedia.uuid) {
          // this.currentMesh = mesh;
          this.addMediaHotspot(this.selectedMedia, mesh);
          this.addMediaInfoHotspot(this.selectedMedia, mesh);
        }
        return mesh;
      });
    }
  }

  removeHotspotMesh() {
    if ($('.hotspot-pulse')) {
      $('.hotspot-pulse').each(function() {
        $(this).remove();
      });
    }
    if ($('.info-outer')) {
      $('.info-outer').each(function() {
        $(this).remove();
      });
    }
    let i;
    for (i = 0; i < this.hotspotsMesh.length; i++) {
        if (this.hotspotsMesh[i]) {
          this.cssScene.remove(this.hotspotsMesh[i]);
        }
    }
    this.hotspotsMesh = [];

    // Remove info hotspot mesh
    let j;
    for (j = 0; j < this.hotspotsInfoMesh.length; j++) {
        if (this.hotspotsInfoMesh[j]) {
          this.cssScene.remove(this.hotspotsInfoMesh[j]);
        }
    }
    this.hotspotsInfoMesh = [];

  }

  rightControls() {
    this.controls.rotateRight();
  }

  leftControls() {
    this.controls.rotateLeft();
  }

  upControls() {
    this.controls.rotateUp();
  }

  downControls() {
    this.controls.rotateDown();
  }

  playPauseVirtualTours() {
    this.playIconClicked = !this.playIconClicked;
    if (this.playIconClicked) {
      this.controls.enableRotate = false;
      this.controls.enableDamping = false;
      this.controls.autoRotate = true;
      this.controls.autoRotateSpeed = 2;
      this.controls.update();
      if (this.soundMesh) {
        this.soundMesh.play();
      }
      // Play / stop highlight reels
      this.autoPlayHideShowCarousel();
    } else {
      this.controls.enableDamping = true;
      this.controls.autoRotate = false;
      this.controls.enableRotate = true;
      if (this.soundMesh) {
        this.soundMesh.pause();
      }
      // Play / stop highlight reels
      this.autoPlayHideShowCarousel();
    }
  }

  zoomInOut( zoomType ) {
    if (this.cameraConfig.isTweening) {
      return;
    }
    let fov;
    const cameraFov = this.camera.fov;
    if (zoomType === 'in') {
      fov = cameraFov - 15;
      if (fov >= 30) {
        this.cameraConfig.isTweening = true;
        const tween = new TWEEN.Tween(this.camera).to({fov}, 300);
        tween.onUpdate(() => {
          this.camera.updateProjectionMatrix();
        });
        tween.onComplete(() => {
          this.cameraConfig.isTweening = false;
        });
        tween.start();
      }
    } else if (zoomType === 'out') {
      fov = cameraFov + 15;
      if (fov <= 75) {
        this.cameraConfig.isTweening = true;
        const tween = new TWEEN.Tween(this.camera).to({fov}, 300);
        tween.onUpdate(() => {
          this.camera.updateProjectionMatrix();
        });
        tween.onComplete(() => {
          this.cameraConfig.isTweening = false;
        });
        tween.start();
      }
    }
  }

  zoomInOutSlider(value) {
    const oldCameraFov = this.cameraFov;
    const cameraFov = this.cameraFov;
    this.cameraFov = value;
    let stepValue;
    let fov;
    if (value > 75 && value > oldCameraFov) {
      stepValue = value - 75;
      fov = 75 - stepValue;
    } else if (value >= 75 && value < oldCameraFov) {
      stepValue = 75 - value;
      fov = 75 + stepValue;
    } else if (value < 75 && value < oldCameraFov) {
      stepValue = 75 - value;
      fov = 75 + stepValue;
    } else if (value < 75 && value > oldCameraFov) {
      stepValue = 75 - value;
      fov = 75 + stepValue;
    } else {
      fov = 75;
    }
    const tween = new TWEEN.Tween(this.camera).to({fov}, 300);
    tween.onUpdate(() => {
      this.camera.updateProjectionMatrix();
    });
    tween.start();
  }

  getPlayPauseText() {
    if (this.playIconClicked) {
      return 'Pause';
    }
    return 'Play';
  }

  getMinMaxText() {
    if (this.fullScreen) {
      return 'FullScreen';
    }
    return 'Exit Screen';
  }
  // Controls functions


  // Mouse control functions
  onMouseMove( event ) {
    if (this.camera) {
      // Image rotation
      this.cameraConfig.manualControl = true;
      // Mouse on hover align with surface
      if (this.mouseBox && this.camera && (event.target && event.target.parentElement && event.target.parentElement.id === 'cssRenderer') ||
          (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssRenderer')
          ) {
            const canvasBounds = this.renderer.getContext().canvas.getBoundingClientRect();
            this.mousePosition.x = ( ( event.clientX - canvasBounds.left ) / ( canvasBounds.right - canvasBounds.left ) ) * 2 - 1;
            this.mousePosition.y = - ( ( event.clientY - canvasBounds.top ) / ( canvasBounds.bottom - canvasBounds.top) ) * 2 + 1;
      } else {
        if (this.mouseBox) {
          this.mouseBox.visible = false;
        }
      }
      // Mouse on hover align with surface

      if (this.cameraConfig.isUserInteracting === true) {
        if (this.camera && (event.target && event.target.parentElement && event.target.parentElement.id === 'cssRenderer') ||
          (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssRenderer')
          ) {
            if (this.playIconClicked) {
              this.playPauseVirtualTours();
            }
            this.closeInfoBox();
      }
        this.cameraConfig.lon = ( this.cameraConfig.onMouseDownMouseX - this.cameraConfig.clientX ) * 0.1 + this.cameraConfig.onMouseDownLon;
        this.cameraConfig.lat = ( this.cameraConfig.clientY - this.cameraConfig.onMouseDownMouseY ) * 0.1 + this.cameraConfig.onMouseDownLat;
      }
    }
  }

  onMouseDown(event) {
    // Remove tool tip if any
    // if ($('.ng-tooltip-show') && $('.ng-tooltip-show').length > 0) {
    //   $('.ng-tooltip-show').each(function() {
    //     $(this).remove();
    //   });
    // }
    this.cameraConfig.manualControl = false;
    if (this.camera) {
      if (this.camera && (event.target && event.target.parentElement && event.target.parentElement.id === 'cssRenderer') ||
          (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssRenderer')
          ) {
          this.closeInfoBox();
        }
      this.cameraConfig.isUserInteracting = true;
      this.cameraConfig.clientX = (event && event.clientX) || (event && event.touches[ 0 ].clientX);
      this.cameraConfig.clientY = (event && event.clientY) || (event && event.touches[ 0 ].clientY);
      this.cameraConfig.onMouseDownMouseX = this.cameraConfig.clientX;
      this.cameraConfig.onMouseDownMouseY = this.cameraConfig.clientY;
      this.cameraConfig.onMouseDownLon = this.cameraConfig.lon;
      this.cameraConfig.onMouseDownLat = this.cameraConfig.lat;
    }
  }

  onMouseUp(event) {
    // Remove tool tip if any
    // if ($('.ng-tooltip-show') && $('.ng-tooltip-show').length > 0) {
    //   $('.ng-tooltip-show').each(function() {
    //     $(this).remove();
    //   });
    // }
    if (this.camera) {
      // Camera rotation and sphere rotation
      this.cameraConfig.isUserInteracting = false;
    }
  }

  onDocumentMouseWheel( event ) {
    if (this.camera) {
      // Image rotation
      if (this.camera && (event.target && event.target.parentElement && event.target.parentElement.id === 'cssRenderer') ||
        (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssRenderer')
        ) {
          $('body').addClass('overflowHidden');
          const deltaY = event.deltaY * 0.05;
          if (deltaY < 0) {
            // Zoom in
            this.zoomInOut('in');
          } else {
            // Zoom out
            this.zoomInOut('out');
          }
      } else {
        $('body').removeClass('overflowHidden');
      }
    }
  }

  preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault) {
        e.preventDefault();
    } else {
        e.returnValue = false;
    }
}

  // Mouse control functions

  // Basic controls function starts from here
  getEmbedUrl(code) {
    return `https://www.youtube.com/embed/${code}`;
  }

  readMoreFunction() {
    this.readMoreClicked = !this.readMoreClicked;
  }

  readMoreSummaryFunction() {
    this.readMoreSummaryClicked = !this.readMoreSummaryClicked;
  }

  getYoutubeImage(code) {
    return `https://img.youtube.com/vi/${code}/hqdefault.jpg`;
  }

  openIframeCode(tag) {
    this.selectedInfoTag = tag;
  }

  openInfoImage(tag) {
    this.selectedInfoImage = tag;
  }

  iframeClose() {
    this.selectedInfoTag = undefined;
  }

  imageClose() {
    this.selectedInfoImage = undefined;
  }

  toggleTitle() {
    this.toggle = !this.toggle;
    if (this.toggle) {
      this.highlightToggle = false;
      this.floorplanToggle = false;
    } else {
      this.toggle = false;
    }
  }
  moreLessButton() {
    this.moreClicked = !this.moreClicked;
  }

  getMoreLessText() {
    if (this.moreClicked) {
      return 'Less';
    }
    return 'More';
  }

  // Highlightreel
  startAnimationAutoplay() {
    const thisobject = this;
    if (this.highLightReelData.length > 0) {
      if (!this.currentHighlightReelData) {
        const highLightReelData = _.find(this.highLightReelData, {media_id: this.selectedMedia.uuid});
        if (highLightReelData) {
          this.currentHighlightReelData = highLightReelData;
        } else {
          this.currentHighlightReelData = this.highLightReelData[0];
        }
      }
      this.autoplayAnimationInterval = setInterval( () => {
        const currentHighlightReelData = thisobject.changeIfItsLastIndexHighlightReel();
        thisobject.changeMediaFromHighlightReel(currentHighlightReelData);
      }, 10000);
    }
  }

  resetCameraPositionForFirstHighlightReel() {
    if (this.currentHighlightReelData && this.selectedMedia && this.selectedMedia.uuid === this.currentHighlightReelData.media_id && this.currentHighlightReelData.coordinates) {
      this.camera.position.set(this.currentHighlightReelData.coordinates.x, this.currentHighlightReelData.coordinates.y, this.currentHighlightReelData.coordinates.z);
    }
  }

  changeIfItsLastIndexHighlightReel() {
    const lastIndexof = _.findLastIndex(this.highLightReelData);
    const currentIndex = _.findIndex(this.highLightReelData, {uuid: this.currentHighlightReelData.uuid });
    // Check if loop config count of highlight reel has been completed
    if (lastIndexof === currentIndex) {
      $(this.selectEvents.nativeElement).trigger('to.owl.carousel', [0, 0]);
      this.currentHighlightReelData = this.highLightReelData[0];
      this.currentHighlightAnimationCount = this.currentHighlightAnimationCount + 1;
      if (this.currentHighlightAnimationCount > this.spaceConfig.highlight_reel_count) {
        this.playPauseVirtualTours();
      }
    } else {
      this.currentHighlightReelData = this.highLightReelData[currentIndex + 1];
      $(this.selectEvents.nativeElement).trigger('next.owl.carousel');
    }
    return this.currentHighlightReelData;
  }

  // changeMediaByHighlightReel(highlightReel) {
  //   const selectedMedia = _.find(this.mediaData, {uuid: highlightReel.media_id});
  //   if (selectedMedia) {
  //     this.changeMedia(selectedMedia);
  //   }
  // }

  changeHighlightReel(highlightReel) {
    if (this.isAnimating) {
      return;
    }
    const selectedMedia = _.find(this.mediaData, {uuid: highlightReel.media_id});
    if (selectedMedia && selectedMedia.uuid !== this.selectedMedia.uuid) {
      this.removeAutoPlay();
      // Change highlight reel data index and values on change of media
      this.currentHighlightReelData = highlightReel;
      this.animateAndChangeMediaForHighLightReel(selectedMedia);
    }
  }

  changeMediaFromHighlightReel(highlightReel) {

    const selectedMedia = _.find(this.mediaData, {uuid: highlightReel.media_id});
    if (selectedMedia) {
      // Change highlight reel data index and values on change of media
      this.currentHighlightReelData = highlightReel;
      this.animateAndChangeMediaForHighLightReel(selectedMedia);
    }
  }

  animateAndChangeMediaForHighLightReel(media) {
    const cubesObject = this.cubesObject && this.cubesObject.children ? this.cubesObject.children : [];
    const nextIndex = _.findIndex(cubesObject, {name: media.uuid });
    if (cubesObject && cubesObject[nextIndex]) {
      this.isAnimating = true;
      const oldMesh = this.currentMesh;
      const newMesh = cubesObject[nextIndex];
      this.currentMesh = newMesh;
      this.currentMesh.visible = true;
      // if (oldMesh.name !== newMesh.name) {
      this.controls.enableRotate = false;
      // Remove hotspots
      this.removeHotspotMesh();

      const originals = oldMesh.userData.originalOpacities;
      const current = { percentage: 1 };
      const tweenOpacity = new TWEEN.Tween(current)
      .to({ percentage: 0 }, 1000)
      .easing(TWEEN.Easing.Linear.None)
      .onUpdate(() => {
        let i;
        for (i = 0; i < oldMesh.material.length; i++) {
          oldMesh.material[i].transparent = true;
          oldMesh.material[i].opacity = originals[i] * current.percentage;
        }
      })
      .onComplete(() => {
        this.cameraFov = 75;
        this.camera.fov = this.cameraFov;
        this.camera.position.set( 0, 0, 0.001 );
        if (this.currentHighlightReelData && this.currentHighlightReelData.coordinates) {
          this.camera.position.set(this.currentHighlightReelData.coordinates.x, this.currentHighlightReelData.coordinates.y, this.currentHighlightReelData.coordinates.z);
        }
        this.camera.updateProjectionMatrix();
        this.tweenPreviousNextImage(newMesh, 'in', 1000);
      });
      tweenOpacity.start();
    }
  }

  stopAnimationAutoplay() {
    clearInterval(this.autoplayAnimationInterval);
    this.autoplayAnimationInterval = undefined;
  }

  autoPlayHideShowCarousel() {
    if (this.playIconClicked) {
      this.startAnimationAutoplay();
    } else {
      this.currentHighlightAnimationCount = 1;
      this.stopAnimationAutoplay();
    }
  }

  toggleHighlight() {
    this.highlightToggle = !this.highlightToggle;
    if (this.highlightToggle) {
      this.floorplanToggle = false;
      this.toggle = false;
      this.infoHotspots = _.map(this.infoHotspots, (d) => {
        d.hidden = true;
        return d;
      });
    }
  }

  changeHighlightReelFromMediaId(mediaId) {
    const highLightReelData = _.find(this.highLightReelData, {media_id: mediaId});
    if (highLightReelData) {
      this.currentHighlightReelData = highLightReelData;
    } else {
      this.currentHighlightReelData = undefined;
    }
  }
  // Highlightreel

  // Floorplan
  getHeightWidthHotspot() {
    if (this.floorPlanImage && this.floorPlanImage.nativeElement) {
      const element = $(this.floorPlanImage.nativeElement);
      const width = element.width() / 22;
      return width < 30 ? width : 30;
    }
  }

  floorPlanHotspotClick(hotspot) {
    if (this.flooplanHotspotClicked) {
      return;
    }
    if (this.isAnimating) {
      return;
    }
    const cubesObject = this.cubesObject.children ? this.cubesObject.children : [];
    if (hotspot && hotspot.media_link && hotspot.media_link.uuid && cubesObject.length > 0) {
      const currentIndex = _.findIndex(cubesObject, {name: hotspot.media_link.uuid });
      if (this.currentMesh && cubesObject[currentIndex]) {
        const oldMesh = this.currentMesh;
        const newMesh = cubesObject[currentIndex];
        if (oldMesh.name !== newMesh.name) {
          this.currentMesh = newMesh;
          this.currentMesh.visible = true;
          this.isAnimating = true;
          this.flooplanHotspotClicked = true;
          this.removeAutoPlay();
          // Remove hotspots
          this.removeHotspotMesh();
          this.changeHighlightReelFromMediaId(newMesh.name);
          this.tweenPreviousNextImage(newMesh, 'in', 1000);
          this.tweenPreviousNextImage(oldMesh, 'out', 2000);
        }
      }
    }
  }

  ngOnDestroy() {
    TWEEN.removeAll();
    this.removeComponentProperties();
    $('body').removeClass('overflowHidden');
  }

  removeComponentProperties() {

    const gl = this.renderer.getContext('webgl');
    if (gl) {
      try {
        gl.getExtension('WEBGL_lose_context').loseContext();
      } catch {
        console.log('error');
      }
    }

    this.removeCssComponents();

    cancelAnimationFrame(this.animateId); // Stop the animation
    this.renderer.domElement.addEventListener('dblclick', null, false); // remove listener to render
    this.scene.remove(this.cubesObject);
    this.cubesObject = null;
    this.scene = null;
    this.camera = null;
    this.controls = null;
    this.empty(this.rendererContainer.nativeElement);
    if (this.soundMesh) {
      this.soundMesh.pause();
    }
    this.removeData();
  }

  removeCssComponents() {
    if ($('.hotspot-pulse')) {
      $('.hotspot-pulse').each(function() {
        $(this).remove();
      });
    }
    if ($('.info-outer')) {
      $('.info-outer').each(function() {
        $(this).remove();
      });
    }
    let i;
    for (i = 0; i < this.hotspotsMesh.length; i++) {
        if (this.hotspotsMesh[i]) {
          this.cssScene.remove(this.hotspotsMesh[i]);
        }
    }
    this.hotspotsMesh = [];
    // Remove info hotspot mesh
    let j;
    for (j = 0; j < this.hotspotsInfoMesh.length; j++) {
        if (this.hotspotsInfoMesh[j]) {
          this.cssScene.remove(this.hotspotsInfoMesh[j]);
        }
    }
    this.hotspotsInfoMesh = [];
    this.cssRenderer.domElement.addEventListener('dblclick', null, false); // remove listener to render
    this.cssScene = null;
    this.empty(this.cssRendererContainer.nativeElement);
  }

  empty(elem) {
    while (elem.lastChild) {
      elem.removeChild(elem.lastChild);
    }
  }

  removeData() {
    this.soundMesh = null;
    this.currentMesh = null;
    if (this.autoplayAnimationInterval) {
      clearInterval(this.autoplayAnimationInterval);
    }
  }

  getOrbitControlsAngle() {
    if (this.controls) {
      return THREE.Math.radToDeg(this.controls.getAzimuthalAngle());
    }
    // console.log('this.controls', this.controls);
  }

  mouseOverFullscreen() {
    if (!this.detectMob()) {
      if (this.fullScreen) {
        this.imgSrc2 = 'assets/images/icons/min-color.png';
      } else {
        this.imgSrc1 = 'assets/images/icons/arrow-color.png';
      }
    }
  }

  mouseOutFullscreen() {
    if (!this.detectMob()) {
      if (this.fullScreen) {
        this.imgSrc2 = 'assets/images/icons/min-icon.png';
      } else {
        this.imgSrc1 = 'assets/images/icons/arrow-icon.png';
      }
    }
  }

}
